
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"16","height":"17","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M9.784 8.614a4.538 4.538 0 00-1.97 3.744c0 .828.222 1.604.609 2.272H1.51c-.282 0-.511-.243-.511-.543v-.68c0-.052.008-.104.025-.158.152-.46.468-.867.938-1.211.366-.268.83-.5 1.378-.692.85-.297 1.732-.416 2.028-.451.016-.002-.013-.768-.004-.782.002-.004 0-.283-.164-.467a.05.05 0 00-.013-.013c-.487-.41-.902-.993-1.205-1.694a.06.06 0 00-.046-.037c-.424-.062-.816-.519-.955-1.131-.152-.672.02-1.304.412-1.556a.065.065 0 00.029-.056c-.021-1.284.288-2.303.919-3.029C5.153 1.196 6.267 1 7.058 1c.79 0 1.904.196 2.716 1.13.63.726.94 1.745.92 3.029-.001.022.01.043.028.056.391.252.564.884.412 1.556-.14.613-.531 1.07-.956 1.131a.06.06 0 00-.046.037c-.1.233-.216.458-.348.675z"}}),_c('path',{attrs:{"d":"M12.358 15.766a3.407 3.407 0 110-6.815 3.407 3.407 0 010 6.815zm.19-3.572v-1.066a.473.473 0 10-.947 0v1.262c0 .145.066.282.18.372.023.02.047.037.074.053l1.694.978a.442.442 0 10.442-.765l-1.444-.834z"}})])
          )
        }
      }
    